export default __webpack_public_path__ + "static/blob1-e7692f088dcac01fe71be86c66e83431.svg";